export default "__VITE_ASSET__Tr48O6Fu__"